/*
Rod Supports
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Rod Supports'
const id = '0w81HJIuk9kUg6vUWwpo'

export default {
  name,
  id,
  filters,
  headers,
  form
}
